import React from 'react';
import Reveal from './Reveal';

const LandingFeatureCard = ({ icon: Icon, title, description, delay = 0 }) => (
  <Reveal delay={delay}>
    <article className="landing-feature-card">
      <div className="landing-feature-card__icon">
        <Icon size={22} strokeWidth={1.75} aria-hidden />
      </div>
      <h3 className="landing-feature-card__title">{title}</h3>
      <p className="landing-feature-card__text">{description}</p>
    </article>
  </Reveal>
);

export default LandingFeatureCard;
